<template>
  <v-container fluid grid-list-md>
    
    <v-layout row wrap>
      <v-flex xs12 class="display-1 font-weight-light">
          FAA STRATEGIC LEADERSHIP CAPABILITIES
      </v-flex>

      <v-flex xs12 sm4 md2>

        <v-card height="100%">
          <v-img height="100%"
            :src="image"
            :lazy-src="image"
          ><template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
          </v-img>
        </v-card>
      </v-flex>

      <v-flex xs12 sm8 md10>
          <p>FLLI embeds FAA’s eight Strategic Leadership Capabilities (SLCs) throughout all training. FLLI training increases awareness and application of the eight SLCs among FAA employees, managers, and future executives.</p>
      </v-flex>


      <v-flex xs12>
        <p></p>
      </v-flex>

      <template v-for="(item,index) in slcList">

        <v-flex xs12 sm6 :key="index">

          <v-card color="indigo darken-4" dark height="100%" class="card-block">

            <v-card-title>
              <div :id="item.id">{{item.name}}</div>
            </v-card-title>            

              <v-card-text class="white text--primary">
                  <p></p>
                  <ul v-for="bullet in item.description">
                    <li>{{bullet}}</li>
                  </ul>
                  <v-spacer></v-spacer>
              </v-card-text>

              <v-spacer class="white"></v-spacer>

              <v-card-actions class="white">
                <v-btn @click="openSLC(item)"
                  text
                  color="orange"
                >
                  Course List
                </v-btn>
              </v-card-actions>
            </v-card>
        </v-flex>
      </template>




    </v-layout>
   
  </v-container>
</template>

<script>
  import slcListsJson from '../json/slc.json'

  export default {
    data () {
        return {
          slcList: slcListsJson,
          image: require('@/assets/strategic_leadership.jpg')
        }
    },
    methods: {
      openSLC(item) {
        this.$router.push({ path: '/list/ALL?slc=' + item.id });
      },

    },
  }
</script>

<style>
.flexcard {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.card-block {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
</style>
